var _g, _circle, _circle2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_518_2756)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.7751,
    cy: 19.3548,
    rx: 19.3552,
    ry: 19.3548,
    fill: "url(#paint0_radial_518_2756)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0977,
    cy: 15.5484,
    r: 2,
    fill: "#39383D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8086,
    cy: 15.5484,
    r: 2,
    fill: "#39383D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9064 29.6814C31.2709 29.5701 31.479 29.1827 31.3356 28.8296C30.7981 27.5054 29.9024 26.3514 28.743 25.5005C27.3976 24.5131 25.7691 23.9868 24.1002 24.0002C22.4313 24.0136 20.8115 24.5659 19.482 25.5747C18.3365 26.4441 17.4594 27.6123 16.9431 28.9449C16.8054 29.3003 17.0196 29.6842 17.3859 29.7898C17.7522 29.8953 18.1311 29.6819 18.2757 29.3293C18.705 28.2818 19.408 27.3636 20.3164 26.6742C21.4089 25.8452 22.7399 25.3914 24.1113 25.3804C25.4826 25.3694 26.8208 25.8019 27.9263 26.6133C28.8457 27.288 29.5633 28.1948 30.0094 29.2353C30.1595 29.5856 30.5419 29.7928 30.9064 29.6814Z",
    fill: "#39383D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_518_2756",
    x: 0.419922,
    y: 0,
    width: 46.7109,
    height: 46.7097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_518_2756"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_518_2756",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_518_2756",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5814 10.4516) rotate(77.6373) scale(28.9289 28.9293)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableSad);
export default __webpack_public_path__ + "static/media/DisableSad.81b71160771bf0add255e31ccfbcb947.svg";
export { ForwardRef as ReactComponent };